<template>
  <div v-if="airline.params.monetary.type.length <= 0">
    {{ lang.monetary_compensation_new.MESSAGE_UNAVAILABLE }}
  </div>
  <form v-else class="option-choose-method content-monetary" @submit.prevent="sendCompensation">
    <div class="row header-text-intro">
      <div class="col-md-10 col-12">
        <span v-if="showIntro">{{ lang.monetary_compensation_new.INTRO }}</span>
        <span v-else>{{ lang.monetary_compensation_new.INTRO.substring(0, 100) + '...' }}</span>
      </div>
      <div class="col-md-2 col-12 text-right">
        <span @click="showIntro = !showIntro">
          <span v-if="showIntro">Hidden</span>
          <span v-else>{{ lang['homepage_new'].SFS_LANG_ROW_26 }}</span>
        </span>
      </div>
    </div>
    <div class="row item-option-compensation align-items-center">
      <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_AMOUNT }}</div>
      <div class="col-7">
        {{ monetary.currency }}
        {{ infoCashOrder.open_amount > 0 ? infoCashOrder.open_amount : monetary.valamount }}
      </div>
    </div>
    <div class="row item-option-compensation">
      <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_TYPE }}</div>
      <div class="col-7">
        <div v-if="showCompensationType('0')" class="custom-control custom-radio mb-3">
          <input
            id="compensation-type-cash"
            v-model="infoMethodMonetary.methode_get"
            type="radio"
            name="compensation-type"
            required
            class="custom-control-input"
            value="1"
          />
          <label class="custom-control-label" for="compensation-type-cash">{{
            lang.monetary_compensation_new.COMPENSATION_TYPE_1
          }}</label>
        </div>
        <div v-if="showCompensationType('1')" class="custom-control custom-radio mb-3">
          <input
            id="compensation-type-future-travel"
            v-model="infoMethodMonetary.methode_get"
            type="radio"
            name="compensation-type"
            required
            class="custom-control-input"
            value="2"
          />
          <label class="custom-control-label" for="compensation-type-future-travel">{{
            lang.monetary_compensation_new.COMPENSATION_TYPE_2
          }}</label>
        </div>
        <div v-if="showCompensationType('2')" class="custom-control custom-radio mb-3">
          <input
            id="compensation-type-bankwire"
            v-model="infoMethodMonetary.methode_get"
            type="radio"
            name="compensation-type"
            required
            class="custom-control-input"
            value="3"
          />
          <label class="custom-control-label" for="compensation-type-bankwire">{{
            lang.monetary_compensation_new.COMPENSATION_TYPE_3
          }}</label>
        </div>
      </div>
    </div>
    <div v-if="infoMethodMonetary.methode_get == 1" class="row item-option-compensation">
      <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_OPTION }}</div>
      <div class="col-7">
        <div class="custom-control custom-radio mb-3">
          <input
            id="compensation-option-1x"
            v-model="infoMethodMonetary.compensation_option"
            type="radio"
            name="compensation-option"
            required
            class="custom-control-input"
            value="0"
          />
          <label class="custom-control-label" for="compensation-option-1x">{{
            lang.monetary_compensation_new.COMPENSATION_OPTION_1
          }}</label>
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            id="compensation-option-multiple"
            v-model="infoMethodMonetary.compensation_option"
            type="radio"
            name="compensation-option"
            required
            class="custom-control-input"
            value="1"
          />
          <label class="custom-control-label" for="compensation-option-multiple">{{
            lang.monetary_compensation_new.COMPENSATION_OPTION_2
          }}</label>
        </div>
      </div>
    </div>
    <div
      v-if="infoMethodMonetary.methode_get == 1 && infoMethodMonetary.compensation_option == 1"
      class="row item-option-compensation align-items-center"
    >
      <div class="col-5">{{ lang.monetary_compensation_new.CASH_PICK_UP_AMOUNT }}</div>
      <div class="col-7">
        <select
          id="cash-pick-up"
          v-model="infoMethodMonetary.amount_cash"
          name="cash-pic-up"
          class="cash-pickup form-control"
          required
          @change="enterAmountCash()"
        >
          <option v-for="(item, index) in amountPickUpMulti" :key="index" :value="item">{{ item }}</option>
        </select>
      </div>
    </div>
    <div
      v-if="
        (infoMethodMonetary.methode_get == 1 && infoMethodMonetary.compensation_option !== '') ||
        infoMethodMonetary.methode_get == 3
      "
      class="row item-option-compensation"
    >
      <div class="col-12 text-center mt-4">
        <button type="submit" class="btnDefault">{{ lang.monetary_compensation_new.SEND_COMPENSATION_REQUEST }}</button>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    secret: {
      type: String,
      default: ''
    },
    service: {
      type: Object,
      default: () => {}
    },
    infoPaxMonetaryDetail: {
      type: Object,
      default: () => {}
    },
    infoCashOrder: {
      type: Object,
      default: () => {}
    },
    monetaryId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      infoMethodMonetary: {
        methode_get: '',
        compensation_option: '0',
        amount_cash: ''
      },
      showIntro: false
    }
  },
  computed: {
    monetary() {
      return _.find(this.service.list_monetary, { id: parseInt(this.monetaryId) })
    },
    amountPickUpMulti() {
      let result = []
      if (_.isEmpty(this.infoCashOrder)) {
        return result
      }

      let amount = this.monetary.valamount
      if (this.infoCashOrder.open_amount > 0) {
        amount = this.infoCashOrder.open_amount
      }

      let step = this.airline.params.pin4.step
      if (step === 0) {
        return
      }
      for (let i = this.airline.params.pin4.min; i <= amount; i += step) {
        result.push(i)
      }
      return result
    }
  },
  created() {
    this.infoMethodMonetary.amount_cash = this.infoCashOrder.open_amount
    if (parseFloat(this.infoCashOrder.open_amount) < parseFloat(this.service.price_per_person)) {
      this.infoMethodMonetary.compensation_option = 1
    }
    if (this.airline.params.monetary && this.airline.params.monetary.type) {
      this.infoMethodMonetary.methode_get = parseInt(this.airline.params.monetary.type[0]) + 1
      this.autoNextStep()
    }
  },
  methods: {
    enterAmountCash: function () {
      if (
        parseInt(this.infoCashOrder.open_amount) > 0 &&
        parseInt(this.infoMethodMonetary.amount_cash) > parseInt(this.infoCashOrder.open_amount)
      ) {
        this.infoMethodMonetary.amount_cash = this.infoCashOrder.open_amount
      } else if (parseInt(this.infoMethodMonetary.amount_cash) > parseInt(this.infoCashOrder.compensation_amount)) {
        this.infoMethodMonetary.amount_cash = this.infoCashOrder.compensation_amount
      }
    },
    sendCompensation: function () {
      if (
        this.infoMethodMonetary.methode_get == 1 &&
        this.infoMethodMonetary.compensation_option == 1 &&
        parseInt(this.infoMethodMonetary.amount_cash) == 0
      ) {
        this.$swal(this.lang.monetary_compensation_new.NOTIFY_ENTER_AMOUNT)
        return
      }
      this.infoMethodMonetary.step = 1
      this.$emit('updateInfoCompensation', this.infoMethodMonetary)
    },
    showCompensationType(type) {
      if (_.isEmpty(this.airline)) {
        return false
      }
      return !!this.airline.params.monetary.type.includes(type)
    },
    autoNextStep() {
      if (this.airline.params.monetary.type.length == 1 && this.infoMethodMonetary.methode_get == 3) {
        this.sendCompensation()
      }
    }
  }
}
</script>
